import template from './templates/tripFlightItem.tmpl.html';
import tripEvents from './../config/events.constant';

export default function TripFlightItem(
    tripFactory,
    l10nService,
    flightsUtils,
    flightFareService,
    tripUtils
) {
    'ngInject';

            return {
                restrict: 'AE',
                template,
                scope: {
                    data: '=',
                    cancellation: '=tripFlightItemCancellation',
                    cancelTrip: '=tripFlightItemCancelTrip',
                    regionalSettings: '=',
                    travellers: '=',
                    tripDetails: '=',
                    isCancelled: '=',
                    itemCannotBeCancelled: '=',
                    getTooltip: '=',
                    showAcceptDismissForBooker: '=',
                    lastReview: '=',
                },
                link: function(scope) {
                    scope.flightFareService = flightFareService;
                    scope.l10n = l10nService;
                    scope.firstFlight = scope.data[0].FlightGroups[0].Flights[0];
                    scope.lastFlight = flightsUtils.lastFlight;
                    scope.findFlightStop = flightsUtils.findFlightStop;
                    scope.collectAllCities = flightsUtils.collectAllCities;
                    scope.findDestination = flightsUtils.findDestination;
                    scope.flightType = flightsUtils.flightType;
                    scope.isTrain = flightsUtils.isItemTrain;
                    scope.generateRulesParameters = tripUtils.generateRulesParameters;
                    scope.showItemReviewStatus = scope.lastReview && scope.lastReview.needToShowTripItems() && scope.showAcceptDismissForBooker();
                    scope.isItemNotIndicated = function(tripItemId) {
                        return scope.showItemReviewStatus && scope.lastReview.getFirstUserReview().isTripItemIdNotInticated(tripItemId);
                    };

                    scope.isTripItemIdApproved = function(tripItemId) {
                        return scope.showItemReviewStatus && scope.lastReview.getFirstUserReview().isTripItemIdApproved(tripItemId);
                    };

                    scope.isTripItemIdDeclined = function(tripItemId) {
                        return scope.showItemReviewStatus && scope.lastReview.getFirstUserReview().isTripItemIdDeclined(tripItemId);
                    };

                    scope.isNotCCUser = scope.tripDetails.ReviewTripInfo.CanBeCommented || scope.tripDetails.ReviewTripInfo.CanBeAccepted;
                    scope.isSingleReviewer = scope.tripDetails.ReviewTripInfo.CanBeAccepted;
                    scope.tripDetails.reviewModel = scope.tripDetails.reviewModel || {flights: {}, cars: {}, hotels: {}, rails: {}};

                    scope.isItemReviewed = function(flightId) {
                        return scope.tripDetails.reviewModel && scope.tripDetails.reviewModel.flights && scope.tripDetails.reviewModel.flights.hasOwnProperty(flightId);
                    };

                    scope.applyReview = function(flight, isAccepted) {
                        scope.tripDetails.reviewModel.flights[flight.Id] = isAccepted;
                    };

                    scope.checkSameAirports = function(flightSegments, segmentIndex, departureBlock) {
                        const segmentsData = [];

                        angular.forEach(flightSegments, function(segment, index) {
                            const flightIndex = (index) ? segment.Flights.length - 1 : 0;
                            segmentsData.push(segment.Flights[flightIndex]);
                        });

                        return flightsUtils.checkSameAirports(segmentsData, segmentIndex, departureBlock);
                    };

                    scope.cancelTripItem = function(item) {
                        scope.$emit(tripEvents.TRIP_CANCEL_ITEM, item);
                    };
                },
            };
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/directives/tripFlightItem.directive.js